export enum ERegistrationFormSteps {
	SelectFlow = 0,
	Email = 1,
	Password = 2,
}
